import PaginationComponent from "../../base/pagination.component";
import {NewsPageService} from "./service/news.page.service";
import {InterfaceNews, InterfaceNewsItem} from "../../interface/press-center/interface.news";
import {NewsBody} from "./news.body";
import {NewsStore} from "../../store/news.store";
import { currentUrl, numberSystemDecimal, searchParams } from '../../common/consts';

export class NewsPage {
    constructor(
        private newsStore: NewsStore,
        private loader: HTMLElement | null,
        private pressCenterNews: HTMLElement[],
        private totalCount: number,
    ) {}
    public initialize(): void {
        const pageContainerNews: HTMLElement | null = document.querySelector('[data-page-container-news]');

        if (pageContainerNews) {
            const itemsCountNews = this.totalCount;
            const itemsOnPageNews = 12;
            if (this.totalCount <= itemsOnPageNews) {
                pageContainerNews.classList.add('hidden');
            } else {
                pageContainerNews.classList.remove('hidden');
            }
            const urlParams = new URLSearchParams(window.location.search);
            const pageParam = urlParams.get('page');
            let startPage = pageParam ? parseInt(pageParam, numberSystemDecimal) : 1;
            if (startPage > Math.ceil(itemsCountNews / itemsOnPageNews)) {
                startPage = 1;

                searchParams.set("page", "1")
                currentUrl.search = searchParams.toString();
                history.pushState(null, '', currentUrl.toString());
                this.setList(1);
            }
            const parent = this;
            const paginationNews = new PaginationComponent({
                container: pageContainerNews,
                maxVisibleElements: 8,
                elementsBetweenDots: 3,
                pageClickCallback: (pageNumber: number) => {
                    parent.setList(pageNumber);
                }
            });

            paginationNews.make(itemsCountNews, itemsOnPageNews, startPage);
        }
    }
    private setList(pageNumber: number): void {
        new NewsPageService(this.loader).getNewsByPage(pageNumber)
            .then((data: InterfaceNews | null) => {
                const dataFeaturedNews: InterfaceNewsItem[] = this.newsStore.getFeaturedNews();

                if (data && dataFeaturedNews) {
                    this.pressCenterNews.forEach((item: HTMLElement) => new NewsBody(
                        item,
                        data.News,
                        data.TotalCount,
                        dataFeaturedNews,
                        this.newsStore,
                        this.loader,
                        this.pressCenterNews
                    ).initialize());
                }
            });
    }
}
